const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
  COMPANY: '/companies',
};

/** Constroi o conjunto list/new/edit/detail para um modulo CRUD. */
const crud = (root: string) => ({
  root,
  list: `${root}/list`,
  new: `${root}/new`,
  edit: (id: number | string) => `${root}/${id}/edit`,
  detail: (id: number | string) => `${root}/${id}`,
});

// ----------------------------------------------------------------------

export const paths = {
  auth: {
    login: `${ROOTS.AUTH}/login`,
    forgotPassword: `${ROOTS.AUTH}/forgot-password`,
    resetPassword: `${ROOTS.AUTH}/reset-password`,
    setPassword: `${ROOTS.AUTH}/set-password`,
  },

  dashboard: {
    root: ROOTS.DASHBOARD,

    // Comercial
    client: crud(`${ROOTS.DASHBOARD}/clients`),
    supplier: crud(`${ROOTS.DASHBOARD}/suppliers`),
    quotation: crud(`${ROOTS.DASHBOARD}/quotations`),
    contract: crud(`${ROOTS.DASHBOARD}/contracts`),
    service: crud(`${ROOTS.DASHBOARD}/services`),

    // Operacoes
    order: crud(`${ROOTS.DASHBOARD}/orders`),
    delivery: crud(`${ROOTS.DASHBOARD}/deliveries`),
    task: crud(`${ROOTS.DASHBOARD}/tasks`),

    // Financeiro
    income: crud(`${ROOTS.DASHBOARD}/incomes`),
    expense: crud(`${ROOTS.DASHBOARD}/expenses`),

    // Eventos
    event: crud(`${ROOTS.DASHBOARD}/events`),

    // Transporte
    vehicle: crud(`${ROOTS.DASHBOARD}/vehicles`),
    driver: crud(`${ROOTS.DASHBOARD}/drivers`),
    route: crud(`${ROOTS.DASHBOARD}/routes`),
    trip: crud(`${ROOTS.DASHBOARD}/trips`),
    maintenance: crud(`${ROOTS.DASHBOARD}/maintenances`),

    // Stock
    product: crud(`${ROOTS.DASHBOARD}/products`),
    stockMovement: crud(`${ROOTS.DASHBOARD}/stock-movements`),

    // Documental e relatorios
    document: crud(`${ROOTS.DASHBOARD}/documents`),
    report: {
      root: `${ROOTS.DASHBOARD}/reports`,
      financial: `${ROOTS.DASHBOARD}/reports/financial`,
      commercial: `${ROOTS.DASHBOARD}/reports/commercial`,
      operational: `${ROOTS.DASHBOARD}/reports/operational`,
    },

    // Administracao
    user: crud(`${ROOTS.DASHBOARD}/users`),
    role: crud(`${ROOTS.DASHBOARD}/roles`),
    permission: {
      root: `${ROOTS.DASHBOARD}/permissions`,
      list: `${ROOTS.DASHBOARD}/permissions/list`,
    },
    audit: {
      root: `${ROOTS.DASHBOARD}/audit`,
      list: `${ROOTS.DASHBOARD}/audit/list`,
    },
    settings: {
      root: `${ROOTS.DASHBOARD}/settings`,
    },

    // Plataforma
    company: {
      root: ROOTS.COMPANY,
      list: `${ROOTS.COMPANY}/list`,
      new: `${ROOTS.COMPANY}/new`,
      edit: `${ROOTS.COMPANY}/edit`,
    },
  },
};
